import axios from 'axios';
import { getCookie } from '../utilities/cookies';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:9100',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

axiosInstance.interceptors.request.use(config => {
  let token = getCookie('accessToken');
  let tokenType = 'accessToken';

  if (!token) {
    token = getCookie('orgToken');
    tokenType = 'orgToken';
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    if (tokenType === 'orgToken') {
      config.headers['org-token'] = token;
    }
  }
  return config;
}, error => {
  return Promise.reject(error);
});

export default axiosInstance; 